import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import { useReactiveVar } from '@apollo/client'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Typography, IconButton } from '@mui/material'
import { string, arrayOf, shape, object } from 'prop-types'
import { userAccountIdVar } from '../../../lib/apollo-client/cache'

export default function RibbonSiteWideMessage({
  testId = 'ribbon-site-wide-message',
  items,
  ...otherProps
}) {
  const {
    text: { json },
    displayOption,
  } = items?.[0]
  const router = useRouter()
  const userAccountId = useReactiveVar(userAccountIdVar)
  const { ribbonSetting, setRibbonSetting, setRibbonHeight } = otherProps
  const [ribbonOption, setRibbonOption] = useState(false)

  const ribbonEl = useRef(null)

  useEffect(() => {
    if (ribbonEl.current) {
      setRibbonHeight(ribbonEl.current.clientHeight)
    }
  }, [ribbonEl.current?.clientHeight])

  useEffect(() => {
    switch (displayOption) {
      case 'HomePageOnly':
        if (router.route === '/') {
          setRibbonOption(true)
        } else {
          setRibbonOption(false)
        }
        break
      case 'PublicationPageOnly':
        if (
          router.route.includes('/books') ||
          router.route === '/member-books' ||
          router.route === '/quick-reference-guides'
        ) {
          setRibbonOption(true)
        } else {
          setRibbonOption(false)
        }
        break
      case 'SiteWideMembers':
        if (userAccountId) {
          // user logged in
          setRibbonOption(true)
        } else {
          setRibbonOption(false)
        }
        break
      case 'SiteWideEveryone':
        setRibbonOption(true)
        break
      default:
    }
  }, [displayOption, router.route])

  return (
    <Box
      style={{
        backgroundColor: '#005E47',
        color: 'white',
        minHeight: 'unset',
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 99999,
        textAlign: 'center',
      }}
      data-testid={testId}
      ref={ribbonEl}
    >
      {(ribbonSetting?.closed ? false : ribbonOption) ? (
        <>
          <Typography
            variant='body2'
            sx={{
              textAlign: 'center',
              '& a': {
                color: 'white',
                textDecoration: 'underline',
                '&:hover': {
                  color: '#EF4060',
                },
              },
              '& p': {
                marginBlockStart: '.5em',
                marginBlockEnd: '.5em',
              },
            }}
          >
            {documentToReactComponents(json)}
          </Typography>
          <IconButton
            aria-label='close'
            size='small'
            onClick={() => {
              setRibbonSetting({ ...ribbonSetting, closed: true })
              setRibbonHeight(0)
            }}
            style={{ position: 'absolute', top: 10, right: 10, color: 'white' }}
          >
            <CloseIcon fontSize='inherit' />
          </IconButton>
        </>
      ) : null}
    </Box>
  )
}

RibbonSiteWideMessage.propTypes = {
  testId: string,
  items: arrayOf(
    shape({
      title: string,
      displayOption: string,
      text: shape({ json: object }),
    })
  ),
}
